import createRecursiveFunction from "./createRecursiveFunction";
var createRecursiveFunctionForAnalytics = function createRecursiveFunctionForAnalytics(callback) {
  return createRecursiveFunction(callback, {
    condition: function condition() {
      return window && typeof window.ga === 'function';
    }
  });
};
export default createRecursiveFunctionForAnalytics;